import { ICategory } from "Dashboard/domain/ICategory";
import { IUnit } from "Dashboard/domain/IUnit";
import { IAverageConsumption } from "../domain/IAverageConsumption";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";

export function haveAverageConsumption(category: ICategory): boolean {
  return category.name === "VEHICLE" || category.name === "MECHANIZATION";
}

export function haveUsage(category: ICategory): boolean {
  return category.name === "VEHICLE" || category.name === "MECHANIZATION";
}

export function averageConsumptionSuffix(unit: IUnit): string {
  switch (unit?.name) {
    case "km":
      return "l/100km";
    case "h":
      return "l/h";
    default:
      return "";
  }
}

export function unitName(unit: IUnit): string {
  switch (unit?.name) {
    case "km":
      return "kilometri";
    case "h":
      return "sati";
    default:
      return "";
  }
}

export function unitNameLabel(unit: IUnit): string {
  switch (unit?.name) {
    case "km":
      return "kilometara";
    case "h":
      return "sati";
    case "kom":
      return "komada";
    case "L":
      return "litara";
    default:
      return unit?.name;
  }
}

export function consumptionLabel(unit: IUnit): string {
  if (unit) {
    switch (unit.name) {
      case "km":
        return "kilometraža";
      case "h":
        return "radni sati";
      case "L":
        return "litara";
      case "kom":
        return "komada";
      default:
        return "";
    }
  } else {
    return "";
  }
}

export function averageConsumption(
  averageConsumption: IAverageConsumption
): string {
  return FormatNumberWithUnitOrNull(averageConsumption.averageConsumption,
    averageConsumptionSuffix(averageConsumption.usageUnit)) ?? '';
}
